var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg16Wave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1223,
    height: 245,
    viewBox: "0 0 1223 245",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.46582 62.0495C21.1325 41.0495 72.8807 1.44476 162.881 1.44476C252.881 1.44476 329.097 48.5735 385.097 114.573C441.097 180.573 537.102 243.863 648.466 243.863C737.466 243.863 822.034 194.037 880.034 161.037C938.034 128.037 1011.47 43.6619 1222.47 52.6619",
    stroke: "#20493C",
    strokeDasharray: "5 5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg16Wave);
export default __webpack_public_path__ + "static/media/16_wave.588430c0f28ff94669f6f09817e93b1e.svg";
export { ForwardRef as ReactComponent };